import { render, staticRenderFns } from "./k-menu.vue?vue&type=template&id=5315fa21&lang=pug&"
import script from "./k-menu.vue?vue&type=script&lang=js&"
export * from "./k-menu.vue?vue&type=script&lang=js&"
import style0 from "./k-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5315fa21')) {
      api.createRecord('5315fa21', component.options)
    } else {
      api.reload('5315fa21', component.options)
    }
    module.hot.accept("./k-menu.vue?vue&type=template&id=5315fa21&lang=pug&", function () {
      api.rerender('5315fa21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-menu.vue"
export default component.exports